export const topLevelDomain = (): string => {
  const {
    location: { hostname },
  } = window
  const tld = hostname.split('.').slice(-1)[0]

  return tld === 'localhost' || tld === 'io' ? 'nl' : tld
}
